import axiosPost from '../axiosPost';

export const cargosUpd = async (arg) => {
    const { id, nombre, codigo, version } = arg;

    const body = {
        "service": "CargoUpd",
        "params": {
            'cargoId': id,
            "cargoNombre": nombre,
            "cargoCod": codigo,
            "cargoVersion": version
        }
    };

    try {
        const result = await axiosPost('Y', body, arg)
        return result.data
    } catch (err) {
        console.log(err)
    }
}